import { Box, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  nav: {
    borderLeft: `1px solid ${theme.palette.divider}`,
    paddingLeft: theme.spacing(2),
  },
  link: {
    display: 'block',
    padding: theme.spacing(0.5, 0),
    color: theme.palette.text.secondary,
    cursor: 'pointer',
    '&:hover': { color: theme.palette.primary.main },
  },
}));

export type Section = { id: string; label: string };

/** A sticky outline of the page's sections that scrolls to each. */
export const OnThisPage = ({ sections }: { sections: Section[] }) => {
  const classes = useStyles();
  return (
    <Box className={classes.nav}>
      <Typography variant="subtitle2" gutterBottom>
        On this page
      </Typography>
      {sections.map(({ id, label }) => (
        <Typography
          key={id}
          variant="body2"
          className={classes.link}
          onClick={() =>
            document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
          }
        >
          {label}
        </Typography>
      ))}
    </Box>
  );
};
